import { Layout } from 'react-admin';
import { AppMenu } from './AppMenu';

export const AppLayout = (props) => <Layout {...props} menu={AppMenu} />;
